<template>
    <div>
        <h2>Scratch 101</h2>
        <p>Scratch er et blokprogrammeringssprog. <br> 
          I Scratch programmerer man ved at sammensætte blokke af kode. <br>
          Scratch er udviklet af forskere fra MIT (Massachusetts Institute of Technology) <br> 
          specielt for at lære børn at kode, <br>
          og er især godt til at lave spil.
        </p>
        <img src="/static/images/learning/dag1/scratch_hello_world.svg" alt="hello world">

        <div class="embeds-big">
          <EmbedYoutube id="98awWpkx9UM" title="Hvad er Scratch" />
          <EmbedYoutube id="ssoRNCtmhVM" title="Hvad er Scratch" />
          <EmbedYoutube id="H7L3Wjtubn4" title="En gennemgang af de forskellige kategorier til kodning i Scratch." />
          <EmbedScratch id="378165352" title="En forklaring af koordinatsystemet i Scratch." hideInside="true" />
        </div>

    </div>
</template>

<script>
import EmbedScratch from '@/components/ScratchEmbed';
import EmbedYoutube from '@/components/YoutubeEmbed';
export default {
  name: 'Links',
  components: {
    EmbedScratch,
    EmbedYoutube
  }
}
</script>


<style>
  .embeds-big {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .embeds-big .scratchEmbed {
    height: calc(360px * 2);
    width: calc(480px * 2);
  }
  .embeds-big .yt-video {
    height: calc(360px * 2);
    width: calc(480px * 2);

  }
  .embeds-big .yt-video .play {
    position: relative;
    width: 960px;
    height: calc(315px * 2);
    margin: 0 auto;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/tips-og-tricks/scratch-101.vue